import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { DISCLAIMER_TYPES } from 'site-modules/shared/components/lead-form/utils/with-dynamic-disclaimer';
import { isCarZingPartner } from 'site-modules/shared/utils/dealer-details-utils';
import { getDisclaimerCopy } from 'site-modules/shared/components/lead-form/unified-lead-form/components/privacy-note/get-disclaimer';
import { TcpaDisclaimer } from './tcpa-disclaimer';

export function PrivacyNote({
  tcpaParentDealershipName = null,
  classNames = 'mb-1_5',
  ctaText = '',
  isSingleSelect = false,
  disclaimerType = DISCLAIMER_TYPES.BASIC,
}) {
  const disclaimer = useMemo(() => {
    return getDisclaimerCopy(disclaimerType, isSingleSelect, ctaText);
  }, [ctaText, isSingleSelect, disclaimerType]);

  if (isCarZingPartner(tcpaParentDealershipName) && ctaText) {
    return (
      <div className={classnames('small d-flex align-items-center', classNames)}>
        <span className="icon-shield-check size-24 align-self-center m-0 pe-0_5 text text-gray-dark" aria-hidden />
        <span className="text-gray-darker">
          By clicking &quot;{ctaText}&quot;, I agree that this information will be provided to CarZing, who will deliver
          it to this dealer.{' '}
          <a target="_blank" rel="noopener noreferrer" href="//www.edmunds.com/about/privacy.html">
            <u>Our collection and use of your personal information</u>
          </a>
        </span>
      </div>
    );
  }

  return (
    <Fragment>
      {tcpaParentDealershipName && <TcpaDisclaimer tcpaParentDealershipName={tcpaParentDealershipName} />}
      <div className={classnames('small d-flex align-items-center', classNames)}>
        {!tcpaParentDealershipName && (
          <span className="icon-shield-check size-24 align-self-center m-0 pe-0_5 text text-gray-dark" aria-hidden />
        )}
        <span className="text-gray-darker">{disclaimer}</span>
      </div>
    </Fragment>
  );
}
PrivacyNote.propTypes = {
  tcpaParentDealershipName: PropTypes.string,
  classNames: PropTypes.string,
  ctaText: PropTypes.string,
  isSingleSelect: PropTypes.bool,
  disclaimerType: PropTypes.oneOf([DISCLAIMER_TYPES.BASIC, DISCLAIMER_TYPES.SPECIFIC]),
};
